/**
 * mv3
 */
import {gsap, Expo, Cubic, ScrollToPlugin} from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin);

export default class mv3 {

  constructor() {
    // クラス名
    this.id = 'c-mv3';
    this.sizes = {
      pc: {
        bgW: 1440,
        bgH: 580,
      },
      sp: {
        bgW: 750,
        bgH: 1304,
      }
    };
    this.el = document.getElementById(this.id);

    if (this.el) {
      this.init();
    }
  }

  init() {
    this.isStarted = false;
    this.isTouch = 'ontouchstart' in window;
    this.touchStartX = 0;
    this.touchMoveY = 0;
    this.touchStartTime = 0;
    this.touchMoveX = 0;
    this.touchMoveY = 0;

    this.timer = null;
    this.scrollToEl = [
      'p-tapestry',
      'p-clearfile',
      'p-token__ninjameshi',
      'p-token__osake',
      'p-glassSet',
      'p-token__puromaido',
    ];

    this.scrollToEl2 = [
      'p-tapestry',
      'p-clearfile',
      'p-clearfile',
      'p-token__ninjameshi',
      'p-token__osake',
      'p-glassSet',
      'p-token__puromaido',
    ];

    this.convert = [
      0, 1, 3, 4, 5, 6
    ];

    this.slides = this.el.querySelectorAll('.c-mv2__conSlide');
    this.covers = this.el.querySelectorAll('.c-mv2__conSlide__cover');
    this.charas = this.el.querySelectorAll('.c-mv2__conSlide__chara');
    this.items = this.el.querySelectorAll('.c-mv2__conSlide__items');
    this.titles = this.el.querySelectorAll('.c-mv2__conSlide__title');
    this.btns = document.querySelectorAll('#p-mvUI__list li');

    this.current = null;
    this.max = this.slides.length;
    this.zIndex = 1;

    this.slides.forEach((btn, i) => {
      //btn.addEventListener('mouseenter', this.pause.bind(this, i));
      //btn.addEventListener('mouseleave', this.play.bind(this, i));
      btn.addEventListener('click', this.scrollTo.bind(this, this.scrollToEl2[i]));
    });

    this.btns.forEach((btn, i) => {
      btn.addEventListener('mouseenter', this.changeSlide.bind(this, this.convert[i]));
      btn.addEventListener('mouseleave', this.play.bind(this, i));
      btn.addEventListener('click', this.scrollTo.bind(this, this.scrollToEl[i]));
    });

    if (this.isTouch) {
      const touchEl = document.getElementById('c-mv3__con');
      touchEl.addEventListener('touchstart', this.swipe.bind(this));
      touchEl.addEventListener('touchend', this.swipe.bind(this));
      touchEl.addEventListener('touchcancel', this.swipe.bind(this));
    }

    window.addEventListener('resize', this.resize.bind(this));
    requestAnimationFrame(this.start.bind(this));
  }

  start() {
    this.slideIn(0);
  }

  slideIn(num) {
    gsap.killTweensOf(this.slides[num], this.covers[num]);

    this.zIndex++;

    gsap.set(this.slides[num], {
      visibility: 'visible',
      zIndex: this.zIndex,
    });

    gsap.fromTo(this.covers[num], {
      width: '0%'
    }, {
      duration: 1.0,
      width: '100%',
      ease: Cubic.easeInOut,
      onComplete: this.slideInComp.bind(this)
    });

    gsap.fromTo(this.charas[num], {
      scale: 1.2,
    }, {
      duration: 1.4,
      scale: 1.0,
      ease: Cubic.easeOut,
    });

    gsap.fromTo(this.items[num], {
      opacity: 0,
      y: 50,
    }, {
      delay: 0.4,
      duration: 0.8,
      opacity: 1,
      y: 0,
      ease: Cubic.easeOut,
    });

    gsap.fromTo(this.titles[num], {
      opacity: 0,
      y: 30,
    }, {
      delay: 0.6,
      duration: 0.8,
      opacity: 1,
      y: 0,
      ease: Cubic.easeOut,
    });

    this.prev = this.current;
    this.current = num;
    this.timer = setTimeout(this.next.bind(this), 3500);
  }

  slideInComp() {
    this.isStarted = true;
    if (this.prev !== null) {
      //gsap.set(this.slides[this.prev], {clearProps: 'all'});
    }
  }

  next() {
    const next = (this.current + 1) % this.max;
    this.slideIn(next);
  }

  pause() {
    if (!this.isStarted) return;
    clearTimeout(this.timer);
  }

  play() {
    clearTimeout(this.timer);
    this.timer = setTimeout(this.next.bind(this), 2500);
  }

  changeSlide(i) {
    if (!this.isStarted) return;
    if (this.current === i) return;
    clearTimeout(this.timer);
    this.slideIn(i);
  }

  swipe(e) {
    //e.preventDefault();

    if (e.type === 'touchstart') {
      /** タッチ開始 */
      this.touchStartX = e.touches[0].pageX;
      this.touchStartY = e.touches[0].pageY;
      this.touchStartTime = Date.now();

    } else if (e.type === 'touchend') {
      /** タッチ完了で状態を判定 */
      this.touchMoveX = e.changedTouches[0].pageX - this.touchStartX;
      this.touchMoveY = e.changedTouches[0].pageY - this.touchStartY;

      let direction = '';
      if (this.touchMoveX > 0) {
        direction = 'prev';
      } else {
        direction = 'next';
      }

      if (Math.abs(this.touchMoveX) > 30 && Date.now() - this.touchStartTime <= 300) {
        // 遷移する
        this.swipeSlide(direction);
      } else if (Math.abs(this.touchMoveX) > (window.innerHeight / 2.5)) {
        // 遷移する
        this.swipeSlide(direction);
      }
    } else {

    }
  }

  swipeSlide(direction) {
    clearTimeout(this.timer);
    if (direction === 'prev') {
      let next = this.current - 1;
      if (next < 0) {
        next = this.max - 1;
      }
      this.slideIn(next);
    } else {
      this.next();
    }
  }

  scrollTo(eID) {
    const offset = this.getOffset(document.getElementById(eID));
    let posY =  offset.offset.top;

    if (eID === 'p-token__osake') {
      posY = posY - 120;
    } else if (eID === 'p-glassSet') {
      posY = posY - 280;
    }

    gsap.to(window, {duration: 1.0, scrollTo: {y: posY, autoKill: false, ease: Expo.easeOut}})
  }

  resize() {

  }

  getOffset(selector) {
    let rect = null;
    if (typeof selector === 'string') {
      rect = document.querySelector(selector).getBoundingClientRect();
    } else if (selector !== undefined) {
      rect = selector.getBoundingClientRect();
    }

    if (rect) {
      return {
        orig: rect,
        offset: {
          top: rect.top + this.getScrollTop(),
          left: rect.left
        }
      }
    }

    return null;
  }

  getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
  }
}
